import "./index.scss";
import React from "react";

function ResetPasswordLayout({ children }) {
  return (
    <div id="ResetPasswordLayout" className="ResetPasswordLayout">
      <div className="form-side col-12 ">{children}</div>
    
    </div>
  );
}

export default ResetPasswordLayout;
